import BaseActionMenu from './BaseActionMenu';

export default BaseActionMenu;
